<template>
  <div
    class="form-control"
    style="padding: 8px 6px; position: relative"
  >
    <div
      :class="`tinymce-heading-fluxo_${id}`"
      style="border: none; outline: none; background: none; padding: 0; margin: 0;"
      placeholder="Digite uma mensagem"
      @blur="updateMessage($event)"
      @input="$emit('input', $event.target.innerHTML)"
      v-html="message"
    />
  </div>
</template>

<script>
import { Vue2TinymceEditor } from 'vue2-tinymce-editor'

export default {
  components: {
    Vue2TinymceEditor,
  },
  model: {
    prop: 'variaveis',
    event: 'atualizarVariaveis',
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    indice: {
      type: [Number, String],
      default: 0,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    variaveis: {
      type: Array,
      default: () => [],
    },
    isTagValue: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    variaveisDisponiveis() {
      return this.variaveis.map((variavel) => {
        return variavel
      })
    },
  },
  mounted() {
    const variaveisDisponiveis = this.variaveisDisponiveis
    const vm = this
    const emailHeaderConfig = {
      selector: `.tinymce-heading-fluxo_${vm.id}`,
      menubar: false,
      inline: true,
      paste_as_text: false,
      plugins: [
        'lists',
        'powerpaste',
        'autolink',
        'emoticons',
        'link',
      ],
      toolbar: !this.isTagValue ? '' : 'undo redo | bold italic underline | emoticons link | customInsertButton customDateButton',
      valid_elements: 'p[style],strong[style],em,span[style],a[href],ul,ol,li,br',
      valid_styles: {
        '*': 'font-size,font-family,color,text-decoration,text-align,border-color,background-color,top,left',
      },
      setup(editor) {
        const getMatchedChars = pattern => vm.variaveisDisponiveis.filter(char => char.label !== 'undefined' && char.label.toLowerCase().indexOf(pattern.toLowerCase()) !== -1)
        const onAction = (autocompleteApi, rng, value) => {
          editor.selection.setRng(rng)
          editor.insertContent(value)
          autocompleteApi.hide()
        }
        editor.ui.registry.addButton('customInsertButton', {
          icon: 'non-breaking',
          text: 'Resposta do usuário',
          onAction(_) {
            editor.insertContent('&nbsp;@')
          },
        })

        /**
         * An autocompleter that allows you to insert special characters.
         * Items are built using the CardMenuItem.
         */
        editor.ui.registry.addAutocompleter('specialchars_cardmenuitems', {
          ch: '@',
          minChars: 0,
          columns: 1,
          highlightOn: ['char_name'],
          onAction,
          fetch: pattern => new Promise(resolve => {
            const results = getMatchedChars(pattern).map(char => ({
              type: 'cardmenuitem',
              value: `{{${char.label}}}`,
              label: char.label,
              items: [
                {
                  type: 'cardcontainer',
                  direction: 'vertical',
                  items: [
                    {
                      type: 'cardtext',
                      text: char.label,
                      name: 'char_name',
                    },
                  ],
                },
              ],
            }))
            resolve(results)
          }),
        })
      },
      powerpaste_word_import: 'clean',
      powerpaste_html_import: 'clean',
    }
    tinymce.init(emailHeaderConfig)
  },
  methods: {
    updateMessage(event) {
      if(this.isTagValue === false) {
        this.$emit('atualizarMessage', event.target.innerText)
      }
      this.$emit('atualizarMessage', event.target.innerHTML)
    },
  },
}
</script>
<style scoped>
.mce-edit-focus p {
  margin: 0;
}
</style>
